import React, {useMemo} from 'react';
import {Table, Button, Dropdown, Input, Grid} from 'semantic-ui-react';
import {useTable, usePagination, useFilters} from 'react-table';
import {invoicesPageSizesCustomOrders} from '../../../common/constants/lists';
import {Filter, DefaultColumnFilter} from './katashikiesListFilters';
import KatashikiesCombosModal from './katashikiesCombosModal';

const KatashikiesListTable = ({tableColumns, tableData}) => {
  const data = useMemo(() => tableData, [tableData]);
  const columns = useMemo(() => tableColumns, []);

  const TablePaginator = ({
    page,
    canPreviousPage,
    pageIndex,
    pageOptions,
    pageSize,
    canNextPage,
    nextPage,
    gotoPage,
    previousPage,
    setPageSize,
  }) => {
    if (page.length) {
      return (
        <Grid className="pagination">
          <Grid.Row>
            <Grid.Column width={4} textAlign="left">
              <Button
                className="navigation-button"
                onClick={() => previousPage()}
                disabled={!canPreviousPage}
                content="Anterior"
              />
            </Grid.Column>
            <Grid.Column width={4} textAlign="right">
              <span>páginas </span>
              <span>
                <Input
                  className="pages-input"
                  type="number"
                  value={pageIndex + 1}
                  min="1"
                  max={pageOptions.length}
                  onChange={(e, {value}) => {
                    const page = value ? Number(value) - 1 : 0;
                    if (page < 1 || page > pageOptions.length) {
                      e.target.value = 1;
                    }
                    gotoPage(page);
                  }}
                />
              </span>{' '}
              <span>de {pageOptions.length}</span>
            </Grid.Column>
            <Grid.Column width={4} textAlign="left">
              <Dropdown
                className="page-sizes-selection"
                selection
                upward
                compact
                value={pageSize}
                options={invoicesPageSizesCustomOrders}
                onChange={(e, {value}) => {
                  setPageSize(Number(value));
                }}
              />
              <span> filas</span>
            </Grid.Column>
            <Grid.Column width={4} textAlign="right">
              <Button
                className="navigation-button"
                onClick={() => nextPage()}
                disabled={!canNextPage}
                content="Siguiente"
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      );
    }
    return null;
  };

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    'state': {pageIndex, pageSize},
  } = useTable(
    {
      columns,
      data,
      'defaultColumn': {'Filter': DefaultColumnFilter},
      'initialState': {'pageIndex': 0, 'pageSize': 10},
      'autoResetFilters': false,
    },
    useFilters,
    usePagination,
    (hooks) => {
      hooks.visibleColumns.push((columns) => [
        ...columns,
        {
          'id': 'combosModal',
          'Header': 'COMBOS',
          'width': 2,
          'Cell': ({row}) => {
            return (
              <div style={{'textAlign': 'center'}}>
                <KatashikiesCombosModal katashikiData={row.original} />
              </div>
            );
          },
          'Filter': null,
        },
      ]);
    },
  );

  return (<>
    <Table className='interactive' striped {...getTableProps()}
      style={{'overflow': 'auto'}}>
      <Table.Header fullWidth>
        {headerGroups.map((headerGroup) => (
          <Table.Row key='headers' {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map((column, index) => (
              <Table.HeaderCell
                key={`title-${index}`}
                textAlign='center'
                {...column.getHeaderProps()}
              >
                {column.render('Header')}
              </Table.HeaderCell>
            ))}
          </Table.Row>
        ))}
        {headerGroups.map((headerGroup) => (
          <Table.Row key='filters' id='filters'>
            {headerGroup.headers.map((column, index) => (
              <Table.HeaderCell
                key={`filter-${index}`}
                className={index === 3 || index === 6 ? 'dropdown-header' : ''}
                textAlign='center'
              >
                {<Filter column={column} />}
              </Table.HeaderCell>
            ))}
          </Table.Row>
        ))}
      </Table.Header>
      <Table.Body {...getTableBodyProps()}>
        {!page.length && (
          <Table.Row>
            <Table.Cell colSpan={6} textAlign='center'>
              No hay datos disponibles
            </Table.Cell>
          </Table.Row>
        )}
        {page.length > 0 &&
          page.map((row, i) => {
            prepareRow(row);
            return (
              <Table.Row key={i} {...row.getRowProps()}>
                {row.cells.map((cell) => {
                  return (
                    <Table.Cell textAlign='center' {...cell.getCellProps()}
                      width={cell.column.width}>
                      {cell.render('Cell')}
                    </Table.Cell>
                  );
                })}
              </Table.Row>
            );
          })}
      </Table.Body>
    </Table>
    <TablePaginator
      page={page}
      canPreviousPage={canPreviousPage}
      pageIndex={pageIndex}
      pageOptions={pageOptions}
      pageSize={pageSize}
      canNextPage={canNextPage}
      nextPage={nextPage}
      gotoPage={gotoPage}
      previousPage={previousPage}
      setPageSize={setPageSize}
    />
  </>
  );
};

export default KatashikiesListTable;
